/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Schedulesend3Inputs */

const en_coinvestments_draftemail_schedulesend3 = /** @type {(inputs: Coinvestments_Draftemail_Schedulesend3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule send`)
};

/**
* | output |
* | --- |
* | "Schedule send" |
*
* @param {Coinvestments_Draftemail_Schedulesend3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_schedulesend3 = /** @type {((inputs?: Coinvestments_Draftemail_Schedulesend3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Schedulesend3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_schedulesend3(inputs)
});
export { coinvestments_draftemail_schedulesend3 as "coInvestments_draftEmail_scheduleSend" }